// extracted by mini-css-extract-plugin
export default {"brandPromo":"DF-z","carousel":"EF-z"};